<template>
  <div class="sky-redeem-step flow-step">
    <h1>Insira os dados da sua assinatura SKY</h1>
    <div>
      <pk-input v-model="sky.cpf" :placeholder="'Digite o seu CPF (apenas números)'" autocomplete="off" mask="###.###.###-##" :error="$v.sky.cpf.$error || errorCode == 404" type="tel" />
      <pk-input v-model="sky.code" :placeholder="'Digite o seu código do cliente'" autocomplete="off" :error="$v.sky.code.$error || errorCode == 401" type="tel" />
      <error-text :active="!!errorCode || !!$v.$error">
          <span v-if="errorCode === 401">O código digitado não pertence ao seu CPF.</span>
          <span v-else-if="errorCode === 402">Seu usuário está inativo.</span>
          <span v-else-if="errorCode === 404">O CPF fornecido não existe em nossa base!</span>
          <span v-else-if="!!errorCode">Algum erro ocorreu, tente novamente.</span>
        </error-text>
      <btn color="purple" :loading="loading" @click="submit">Confirmar</btn>
    </div>
  </div>
</template>

<script>
import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapActions, mapState } from 'vuex'
import skylerAPI from '@/api/skyler'
import { cpf } from '@/js/validationUtils'
import formSubmit from '@/js/mixins/formSubmit'

export default {
  name: 'sky-redeem-step',
  mixins: [formSubmit('createSubscription')],
  data: () => ({
    loading: false,
    sky: {
      cpf: '',
      code: ''
    }
  }),
  validations: {
    sky: {
      cpf: { required, numeric, cpf, minLength: minLength(11), maxLength: maxLength(11) },
      code: { required, numeric }
    }
  },
  computed: mapState({ accountId: state => state.user.accountId }),
  methods: {
    ...mapActions({ verifyProfile: 'user/verifyProfile' }),
    async createSubscription() {
      await skylerAPI.createSubscription(this.accountId, this.sky.cpf, this.sky.code)
      await this.verifyProfile()
      this.$emit('subscriptionCreated')
    }
  }
}
</script>

<style lang="scss">
.sky-redeem-step {
  > h1 {
    text-align: center;
  }

  > div {
    max-width: 400px;
    padding-top: 8px;
    margin: 0 auto;

    .btn {
      margin: 0 auto;
      width: 100%;
      margin-top: 12px
    }
  }
}
</style>
